import { SET_MOBILE_USER } from "../actions/mobile-role-action";

const initialState = {
  mobileRoleData: {},
};

const mobileRoleReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MOBILE_USER:
      return {
        ...state,
        mobileRoleData: action.data?.userStatusData,
      };
    default:
      return state;
  }
};

export default mobileRoleReducer;
